import { Facebook, ExternalLink } from "lucide-react";
import { SOCIAL, buildFacebookPagePluginUrl } from "../lib/social";

/**
 * Embedded Facebook Page Plugin (timeline) for the Fedevo 2.0 page.
 * Falls back gracefully (button only) if the iframe is blocked by FB privacy mode.
 */
export const FacebookEmbed = ({ height = 480 }) => {
  const src = buildFacebookPagePluginUrl({
    href: SOCIAL.facebook.url,
    width: 500,
    height,
    tabs: "timeline",
  });

  return (
    <section
      data-testid="facebook-embed"
      className="max-w-[1400px] mx-auto px-6 py-12 border-t border-[color:var(--border)]"
    >
      <div className="flex items-end justify-between mb-6 flex-wrap gap-3">
        <div className="flex items-center gap-3">
          <Facebook className="w-5 h-5 text-[#1877F2]" />
          <h2 className="font-display text-3xl">Suivez-nous sur Facebook</h2>
          <span className="text-[10px] uppercase tracking-[0.3em] text-[color:var(--text-muted)]">
            Fede VO · l'actu en direct
          </span>
        </div>
        <a
          href={SOCIAL.facebook.url}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="fb-cta"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1877F2] text-white text-xs uppercase tracking-widest font-semibold hover:brightness-110 transition shadow-lg"
        >
          <Facebook className="w-3.5 h-3.5" /> Aimer la page
          <ExternalLink className="w-3 h-3 opacity-70" />
        </a>
      </div>

      <div className="grid lg:grid-cols-[1fr_auto] gap-6 items-start">
        <div
          className="rounded-2xl overflow-hidden border border-[color:var(--border)] bg-[#0c1518] flex items-center justify-center min-h-[400px]"
          data-testid="fb-iframe-wrap"
        >
          <iframe
            title="Page Facebook Fedevo 2.0"
            src={src}
            width="500"
            height={height}
            style={{ border: "none", overflow: "hidden", maxWidth: "100%" }}
            scrolling="no"
            frameBorder="0"
            allowFullScreen={true}
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            loading="lazy"
            data-testid="fb-iframe"
          />
        </div>
        <aside className="space-y-3 lg:max-w-xs">
          <div className="rounded-2xl border border-[color:var(--border)] bg-[color:var(--bg-elev)] p-5">
            <div className="text-[10px] uppercase tracking-[0.3em] text-[color:var(--accent)] mb-2">
              Pourquoi nous suivre
            </div>
            <ul className="space-y-2 text-sm text-[color:var(--text-muted)]">
              <li className="flex gap-2"><span className="text-[color:var(--accent)]">·</span> Annonces en avant-première</li>
              <li className="flex gap-2"><span className="text-[color:var(--accent)]">·</span> Backstages des émissions</li>
              <li className="flex gap-2"><span className="text-[color:var(--accent)]">·</span> Lives et battles partagés</li>
              <li className="flex gap-2"><span className="text-[color:var(--accent)]">·</span> Communauté hip-hop active</li>
            </ul>
          </div>
          <a
            href={SOCIAL.facebook.url}
            target="_blank"
            rel="noopener noreferrer"
            className="block text-xs uppercase tracking-widest text-[color:var(--text-muted)] hover:text-[#1877F2] transition px-2"
          >
            facebook.com/Fedevo →
          </a>
        </aside>
      </div>
    </section>
  );
};

export default FacebookEmbed;
